<template>
    <div class="mt-32 sm:mt-56">
        <div class="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
            <h2
                class="text-base/7 font-semibold text-brand-dark dark:text-brand-accent"
            >
                A few simple steps
            </h2>
            <p
                class="mt-2 max-w-lg text-pretty text-4xl font-semibold tracking-tight text-gray-900 dark:text-gray-100 sm:text-5xl"
            >
                Create, Share, Analyze
            </p>
            <div
                class="max-lg:max-w-md mt-10 mx-auto grid grid-cols-1 gap-4 sm:mt-16 lg:grid-cols-6 lg:grid-rows-2"
            >
                <div class="relative lg:col-span-3">
                    <div
                        class="absolute inset-px rounded-lg bg-white dark:bg-gray-200/15 max-lg:rounded-t-[1rem] lg:rounded-tl-[1rem]"
                    />
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] max-lg:rounded-t-[calc(1rem+1px)] lg:rounded-tl-[calc(1rem+1px)]"
                    >
                        <img
                            class="h-80 object-cover object-left opacity-90 dark:opacity-60"
                            src="/assets/01KRKTC36FHTKSQC69SHAQ45BW.webp"
                            alt="Qualta templates select field screenshot"
                        />
                        <div
                            class="p-10 bg-linear-to-b dark:bg-none from-white to-gray-100"
                        >
                            <div
                                class="pl-3 border-l-2 border-brand-dark dark:border-brand-light"
                            >
                                <p
                                    class="mt-2 text-lg font-medium tracking-tight text-purple-dark dark:text-gray-100"
                                >
                                    Create Guides quickly
                                </p>
                                <p
                                    class="mt-2 max-w-lg text-base/6 text-gray-800 dark:text-gray-300"
                                >
                                    Use our prompt templates to set up your
                                    interview Guides with ease. Connect one of
                                    our apps to access platform-specific
                                    templates.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5 max-lg:rounded-t-[1rem] lg:rounded-tl-[1rem]"
                    />
                </div>
                <div class="relative lg:col-span-3">
                    <div
                        class="absolute inset-px rounded-lg bg-white dark:bg-gray-200/15 lg:rounded-tr-[1rem]"
                    />
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] lg:rounded-tr-[calc(1rem+1px)]"
                    >
                        <img
                            class="h-80 object-cover object-left lg:object-right opacity-80 dark:opacity-60"
                            src="/assets/01JKDTF8BEE9HJDA4RSJZRKJVM.webp"
                            alt=""
                        />
                        <div
                            class="p-10 bg-linear-to-b dark:bg-none from-white to-gray-100"
                        >
                            <div
                                class="pl-3 border-l-2 border-brand-dark dark:border-brand-light"
                            >
                                <p
                                    class="mt-2 text-lg font-medium tracking-tight text-purple-dark dark:text-gray-100"
                                >
                                    Share the link
                                </p>
                                <p
                                    class="mt-2 max-w-lg text-base/6 text-gray-800 dark:text-gray-300"
                                >
                                    Start collecting responses by sharing the
                                    public link found on your Guide. The link
                                    will send users to our mobile-friendly chat
                                    interface.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5 lg:rounded-tr-[1rem]"
                    />
                </div>
                <div class="relative lg:col-span-2">
                    <div
                        class="absolute inset-px rounded-lg bg-white dark:bg-gray-200/15 lg:rounded-bl-[1rem]"
                    />
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] lg:rounded-bl-[calc(1rem+1px)]"
                    >
                        <img
                            class="h-80 object-cover object-left opacity-80 dark:opacity-60"
                            src="/assets/01JKDTF8BF9VEZKVT3QK1ZP9T3.webp"
                            alt=""
                        />
                        <div
                            class="p-10 bg-linear-to-b dark:bg-none from-white to-gray-100"
                        >
                            <div
                                class="pl-3 border-l-2 border-brand-dark dark:border-brand-light"
                            >
                                <p
                                    class="mt-2 text-lg font-medium tracking-tight text-purple-dark dark:text-gray-100"
                                >
                                    Get the full picture
                                </p>
                                <p
                                    class="mt-2 max-w-lg text-base/6 text-gray-800 dark:text-gray-300"
                                >
                                    Collect demographic information to add
                                    social context to your responses.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5 lg:rounded-bl-[1rem]"
                    />
                </div>
                <div class="relative lg:col-span-2">
                    <div
                        class="absolute inset-px rounded-lg bg-white dark:bg-gray-200/15"
                    />
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)]"
                    >
                        <img
                            class="h-80 object-cover object-right opacity-80 dark:opacity-60"
                            src="/assets/01JKDTF8BF9VEZKVT3QK1ZP9T5.webp"
                            alt=""
                        />
                        <div
                            class="p-10 bg-linear-to-b dark:bg-none from-white to-gray-100"
                        >
                            <div
                                class="pl-3 border-l-2 border-brand-dark dark:border-brand-light"
                            >
                                <p
                                    class="mt-2 text-lg font-medium tracking-tight text-purple-dark dark:text-gray-100"
                                >
                                    Analyze the responses
                                </p>
                                <p
                                    class="mt-2 max-w-lg text-base/6 text-gray-800 dark:text-gray-300"
                                >
                                    Analyze interview responses for actionable
                                    insights.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5"
                    />
                </div>
                <div class="relative lg:col-span-2">
                    <div
                        class="absolute inset-px rounded-lg bg-white dark:bg-gray-200/15 max-lg:rounded-b-[1rem] lg:rounded-br-[1rem]"
                    />
                    <div
                        class="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] max-lg:rounded-b-[calc(1rem+1px)] lg:rounded-br-[calc(1rem+1px)]"
                    >
                        <img
                            class="h-80 object-cover object-left opacity-80 dark:opacity-60"
                            src="/assets/01JKDTF8BF9VEZKVT3QK1ZP9T8.webp"
                            alt=""
                        />
                        <div
                            class="p-10 bg-linear-to-b dark:bg-none from-white to-gray-100"
                        >
                            <div
                                class="pl-3 border-l-2 border-brand-dark dark:border-brand-light"
                            >
                                <p
                                    class="mt-2 text-lg font-medium tracking-tight text-purple-dark dark:text-gray-100"
                                >
                                    Bring your colleagues
                                </p>
                                <p
                                    class="mt-2 max-w-lg text-base/6 text-gray-800 dark:text-gray-300"
                                >
                                    Depending on their role, they can help you
                                    create, manage, and review Guides.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="pointer-events-none absolute inset-px rounded-lg shadow-sm ring-1 ring-black/5 max-lg:rounded-b-[1rem] lg:rounded-br-[1rem]"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
